import Icon from '@assets/icon_config'
import { formatDisplayDate } from '@utils/helpers'
import React from 'react'
import { Vital as VitalType } from '../useVitals'
import './vital.scss'

export type VitalProps = {
  vital: VitalType,
  onEdit: () => void,
  onShowGraph: () => void
}

export const Vital: React.FC<VitalProps> = (props) => {
  let vital = props.vital
  return (
    <div className="ui-vital">
      <div className="ui-vital__icon">
        <Icon name={vital.actualName} />
      </div>
      <div className="ui-vital__content">
        <div className="ui-vital__content__header">
          <div className="ui-vital__content__header__name">
            {vital.displayName}
            {
              vital.canEdit && <div className="ui-vital__content__header__edit" onClick={props.onEdit}>
                <i className="icon icon-edit"></i>
              </div>
            }
          </div>
          {
            vital.haveGraph && <div className="ui-vital__content__header__graph" onClick={props.onShowGraph}>
              <i className="icon icon-external-link"></i>
            </div>
          }
        </div>
        <div className={`ui-vital__content__value ui-vital__content__value--${vital.inRange}`}>
          {vital.value}
        </div>
        <div className="ui-vital__content__date">
          {formatDisplayDate(vital.refreshDate, 'createDateFormat', 'LastGapClosedFormat')}
        </div>
      </div>
    </div>
  )
}
